<app-preloader *ngIf="settings.isShowingLoader()"></app-preloader>
<div class="chart-banner"></div>
<div class="chart-background pt-70">
  <div class="container">
    <div class="section-title">
      <h2>Le nostre <span>Classifiche</span></h2>
      <p>Scegli fra settimanali o mensili. Seleziona il social che ti interessa, scegli il mese o la settimana e
        via! Scopri subito chi è in testa.</p>
    </div>
    <div class="tabset why-we-different-tabset">
      <input aria-controls="weekly" [checked]="isWeeklyChecked" id="tab1" name="tabset" type="radio">
      <label for="tab1">Classifiche settimanali</label>

      <input aria-controls="monthly" [checked]="isMonthlyChecked" id="tab2" name="tabset" type="radio">
      <label for="tab2">Classifiche mensili</label>

      <div class="tab-panels">
        <div class="tab-panel" id="weekly">
          <div class="row align-items-center">
            <div class="contact-form">
              <form #weeklyChartForm="ngForm" (ngSubmit)="submitWeeklyForm(weeklyChartForm.value)">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="form-group mb-3">
                      <h5 class="pb-2">Seleziona il social</h5>
                      <select #weekSocial="ngModel"
                              [(ngModel)]="socialSelected"
                              class="form-control"
                              id="weekSocial"
                              name="weekSocial"
                              ngModel
                              (change)="onChangeWeekSocial($event, weeklyChartForm)"
                              required>
                        <option *ngFor="let s of socials; index as i" [value]="s.value">{{ s.name }}</option>
                      </select>
                      <div
                        *ngIf="weekSocial.touched && !weekSocial.valid && (weekSocial.errors && weekSocial.errors.required)"
                        class="alert alert-danger">
                        E' necessario selezionare un social network!
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="form-group mb-3">
                      <h5 class="pb-2">Scegli la settimana</h5>
                      <select [disabled]="isWeekDisabled"
                              [(ngModel)]="weekSelected"
                              #week="ngModel"
                              class="form-control"
                              id="week"
                              name="week"
                              ngModel
                              required>
                        <option *ngFor="let s of weeklyChartsAvailable; index as i" [value]="s.id">
                          {{ s.dateFrom | date: 'dd/MM/yyyy' }} - {{ s.dateTo | date: 'dd/MM/yyyy' }}
                        </option>
                      </select>
                      <div
                        *ngIf="week.touched && !week.valid && (week.errors && week.errors.required)"
                        class="alert alert-danger">
                        E' necessario selezionare una data!
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 pt-2">
                    <button [class.disabled]="!weeklyChartForm.valid"
                            class="btn btn-primary float-end"
                            type="submit">Vai alla classifica
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="tab-panel" id="monthly">
          <div class="row align-items-center">
            <div class="contact-form">
              <form #monthlyChartForm="ngForm" (ngSubmit)="submitMonthlyForm(monthlyChartForm.value)">
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <div class="form-group mb-3">
                      <h5 class="pb-2">Seleziona il social</h5>
                      <select #monthSocial="ngModel"
                              [(ngModel)]="socialSelected"
                              class="form-control"
                              id="monthSocial"
                              name="monthSocial"
                              ngModel
                              (change)="onChangeMonthSocial($event, monthlyChartForm)"
                              required>
                        <option *ngFor="let s of socials; index as i" [value]="s.value">{{ s.name }}</option>
                      </select>
                      <div
                        *ngIf="monthSocial.touched && !monthSocial.valid && (monthSocial.errors && monthSocial.errors.required)"
                        class="alert alert-danger">
                        E' necessario selezionare un social network!
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <div class="form-group mb-3">
                      <h5 class="pb-2">Scegli il mese</h5>
                      <select [disabled]="isMonthDisabled"
                              [(ngModel)]="monthSelected"
                              #month="ngModel"
                              class="form-control"
                              id="month"
                              name="month"
                              ngModel
                              required>
                        <option *ngFor="let s of monthlyChartsAvailable; index as i" [value]="s.id">
                          {{ getMonthFromDate(s.dateFrom) }}
                        </option>
                      </select>
                      <div
                        *ngIf="month.touched && !month.valid && (month.errors && month.errors.required)"
                        class="alert alert-danger">
                        E' necessario selezionare un social network!
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 pt-2">
                    <button [class.disabled]="!monthlyChartForm.valid"
                            class="btn btn-primary float-end"
                            type="submit">Vai alla classifica
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mt-2 pb-70">
  <div *ngIf="instagramPosts.length > 0">
    <!--<div (scrolled)="onScrollInstagramPost()"
         [infiniteScrollDistance]="1"
         class="row mt-4"
         infinite-scroll>-->
      <div *ngFor="let post of instagramPosts; let i = index">
        <div class="chart-row mt-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col-1">
                  <h1 class="d-flex align-content-center flex-wrap">{{ i + 1 }}</h1>
                </div>
                <div class="col-11">
                  <div class="chart-info-post">
                    <img alt="post" class="shadow rounded" [src]=post.instagramPostDTO.previewLink>
                    <h3>{{ post.instagramPostDTO.caption.length > 100 ? post.instagramPostDTO.caption.substring(0, 100) + "..." : post.instagramPostDTO.caption }}</h3>
                    <span>Like: {{ post.instagramPostDTO.likesCount }}</span>
                    <small>Data: {{ getPostDate(post.instagramPostDTO.postDate) }} {{ post.instagramPostDTO.postDate | date: 'HH:mm' }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="chart-info-influencer">
                <h3>{{ post.instagramPostDTO.influencerDTO.username }}</h3>
                <span>{{ post.instagramPostDTO.influencerDTO.nickName }}</span>
                <img class="shadow rounded-circle"
                     [src]=post.instagramPostDTO.influencerDTO.avatarLink
                     alt="{{post.instagramPostDTO.influencerDTO.nickName}}">
              </div>
            </div>
          </div>
        </div>
      </div>
   <!-- </div>-->
  </div>
  <div *ngIf="tiktokPosts.length > 0">
  <!--  <div (scrolled)="onScrollTikTokPost()"
         [infiniteScrollDistance]="1"
         class="row mt-4"
         infinite-scroll>-->
      <div *ngFor="let post of tiktokPosts; let i = index">
        <div class="chart-row mt-2" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col-1">
                  <h1 class="d-flex align-content-center flex-wrap">{{ i + 1 }}</h1>
                </div>
                <div class="col-11">
                  <div class="chart-info-post">
                    <img alt="post" class="shadow rounded" [src]=post.tikTokPostDTO.previewLink>
                    <h3>{{ post.tikTokPostDTO.title.length > 100 ? post.tikTokPostDTO.title.substring(0, 100) + "..." : post.tikTokPostDTO.title }}</h3>
                    <span>Hearts: {{ post.tikTokPostDTO.heartsCount }}</span>
                    <small>Data: {{ getPostDate(post.tikTokPostDTO.postDate) }} {{ post.tikTokPostDTO.postDate | date: 'HH:mm' }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="chart-info-influencer">
                <h3>{{ post.tikTokPostDTO.influencerDTO.username }}</h3>
                <span>{{ post.tikTokPostDTO.influencerDTO.nickName }}</span>
                <img [src]=post.tikTokPostDTO.influencerDTO.avatarLink
                                                 alt="{{post.tikTokPostDTO.influencerDTO.nickName}}"
                                                 class="shadow rounded-circle">
              </div>
            </div>
          </div>
        </div>
      </div>
   <!-- </div>-->
  </div>
</div>

